export const SET_SELECTED_TINS = 'SET_SELECTED_TINS';
export const SET_LINE_OF_BUSINESS = 'SET_LINE_OF_BUSINESS';
export const SET_TIME_PERIOD = 'SET_TIME_PERIOD';
export const SET_SERVICE_TYPE = 'SET_SERVICE_TYPE';
export const SET_CLAIM_TYPE = 'SET_CLAIM_TYPE';
export const SET_VENDOR_NAME = 'SET_VENDOR_NAME';
